import React, { useCallback } from 'react';
import { texts } from '../../../consts/Texts';
import { useHMapContext } from '../hooks/useHMapContext';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { reExportedColors, Input } from '../../../components/1elements';
import MapViewSelect from '../../../components/2compounds/Select/MapViewSelect';
import { heatmapCustomEvents } from '../const/HMapEvents';

function HMapSearch() {
  const classes = useStyles();
  const { searchConfig, currentMapInfo } = useHMapContext();
  const [searchSettings, handleSearchSettingsChange] = searchConfig;
  const { text } = searchSettings;
  const [currentMap] = currentMapInfo;


  const startSearch = useCallback(() => {
    const startSearchEvent = new CustomEvent(heatmapCustomEvents.START_SEARCH, {
      detail: { currentMap }
    });
    document.dispatchEvent(startSearchEvent);
  }, [currentMap]);

  const handleSearchTextClearSearch = () => {
    /**
     * to be addressed later:
     * alternative: panToBounds
     */
    handleSearchSettingsChange({ text: '' });
    // FIXME: Hack, event received earlier than react updates state ¯\＿(ツ)＿/¯
    setTimeout(startSearch, 0);
  };

  const handleSearchTextChange = (e) => {
    handleSearchSettingsChange({ text: e.target.value });
  };

  const handleSearchTextKeypress = (e) => {
    /**
     * to be addressed later:
     * alternative: panToBounds
     */
    if (e.keyCode === 13) {
      startSearch();
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.searchDiv}>
        <Input
          autoComplete="off"
          name="q"
          value={text || ''}
          onChange={handleSearchTextChange}
          onClear={handleSearchTextClearSearch}
          variant="outlined"
          type="search"
          id="search-location"
          placeholder={texts.searchText}
          onKeyDown={handleSearchTextKeypress}
          searchFieldClassName={classes.hmapSearchText}
        />
        <MapViewSelect
          isHeatmap
          className={classes.hmapSearchOptions}
        />
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 10,
    position: 'absolute',
    top: '20px',
    left: '10px'
  },
  autocomplete: {
    fontSize: 13,
    width: '430px',
    border: 'none',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: '4px',
    boxSizing: 'border-box',
    marginTop: '4px',
    maxHeight: '400px',
    overflowX: 'hidden',
    fontFamily: 'Roboto',
    background: theme.palette.quaternary.main
  },
  autocompleteMobile: {
    boxShadow: '0px 0px 3px #00000029',
    margin: '4px 0 0 -10px'
  },
  secondSearch: {
    width: 'fit-content',
    height: '40px',
    padding: '10px 15px 0',
    top: '6px',
    left: '40rem',
    zIndex: '10',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '500',
    border: 'none',
    backgroundColor: reExportedColors.WHITE, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    position: 'absolute',
    borderRadius: '40px',
    boxShadow: '0px 0px 3px #00000029',
    cursor: 'pointer'
  },
  secondSearchIcon: {
    height: 20,
    width: 20,
    color: reExportedColors.GOOGLE_BLUE,
    margin: '0 4px 4px 0'
  },
  query: {
    borderBottom: `1px solid ${reExportedColors.LIGHT_GREY}`, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    padding: '3px 0 3px 8px',
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.secondary.main
    }
  },
  locIcons: {
    width: '1em',
    height: '17px'
  },
  threeResult: {
    paddingTop: 8
  },
  hideThreeResult: {
    display: 'none'
  },
  subResult: {
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      background: reExportedColors.HOVER /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    }
  },
  searchDiv: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',

    '& .MuiFormControl-root': {
      borderRadius: '5px',
      boxShadow: '1px 1px 5px 0px #00000040'
    }
  },
  viewMore: {
    margin: '7px 0',
    padding: '3px 0',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '4px',
    '&:hover': {
      background: reExportedColors.HOVER /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    }
  },
  headerDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    top: 0,
    height: 30
  },
  resultCount: {},
  noResultMessage: {
    margin: '10px 0'
  },
  collapseButton: {
    background: theme.palette.quaternary.accent,
    position: 'sticky',
    bottom: 0,
    left: 0,
    width: '100%',
    cursor: 'pointer',
    height: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflowY: 'hidden'
  },
  collapseButtonIcon: {
    fontSize: '26px',
    transform: (props) =>
      props.collapseIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform .25s',
    color: theme.palette.primary.main
  },
  innerDiv: {
    overflowY: 'auto',
    maxHeight: (props) => (props.collapseIsOpen ? '385px' : '0'),
    padding: (props) => (props.collapseIsOpen ? '15px 12px 0' : '0 12px'),
    transition: 'max-height .25s, padding .25s'
  },
  advancedSearch: {
    position: 'absolute',
    left: '435px',
    zIndex: 2
  },
  hamapFilterButton: {
    marginLeft: '5px'
  },
  hmapSearchText: {
    width: '300px'
  },
  hmapSearchOptions: {
    minWidth: '170px'
  }
}));

export default React.memo(HMapSearch);
